import React, { useEffect, useState, useContext } from "react";
import {
  TextInput,
  PasswordInput,
  Anchor,
  Paper,
  Title,
  Text,
  Textarea,
  Container,
  FileInput,
  Button,
} from "@mantine/core";
import { useHistory } from "react-router-dom";
import { User, Image } from "phosphor-react";
import { UserContext } from "../context/User";
import axios from "axios";
import { showNotification } from "@mantine/notifications";
const CompleteProfile = () => {
  const [imgobj, setimgobj] = useState([]);
  const history = useHistory();
  const [desc, setdesc] = useState("");
  const [previewpic, setPreviewpic] = useState("");
  const { setUserInfo, UserInfo } = useContext(UserContext);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handlesave = (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    if (imgobj.length === 0) {
      setError("Please upload an image");
      setLoading(false);
    } else {
      const formData = new FormData();
      formData.append("file", imgobj);
      formData.append("upload_preset", "kxy10xnr");
      axios
        .post(
          "https://api.cloudinary.com/v1_1/dwzjfylgh/image/upload",
          formData
        )
        .then((res) => {
          axios
            .put(
              "https://swipett.herokuapp.com/editprofile",
              {
                description: desc,
                avatar: res.data.secure_url,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            )
            .then(() => {
              setUserInfo({
                username: UserInfo.username,
                avatar: res.data.secure_url,
                desc: desc,
              });
              setLoading(false);
              showNotification({
                title: "Profile Updated",
                message: `Enjoy using Swipet 🐶`,
              });
              history.push("/profile");
            })
            .catch((err) => {
              setError(err.response.data.message);
              setLoading(false);
            });
        });
    }
  };
  return (
    <div>
      <Container size={420} my={40}>
        <Title
          style={{ fontSize: "1.6rem" }}
          align="center"
          sx={(theme) => ({
            fontFamily: `Greycliff CF, ${theme.fontFamily}`,
            fontWeight: 900,
          })}
        >
          <span
            onClick={() => {
              history.push("/profile");
            }}
            style={{ cursor: "pointer" }}
          >
            &#x2190;
          </span>
          {""}
          {""}
          {""} Edit your profile 🐰
        </Title>

        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          {error && (
            <Text color="red" size="sm" align="left" mt={5}>
              {error}
            </Text>
          )}
          <form
            onSubmit={(e) => {
              handlesave(e);
            }}
          >
            {" "}
            <Textarea
              onChange={(e) => {
                setdesc(e.target.value);
              }}
              mt="sm"
              placeholder="Describe yourself"
              label="Description"
              autosize
              minRows={2}
              required
              maxLength={50}
            />
            <FileInput
              icon={<Image />}
              mt="sm"
              placeholder="Upload image"
              required
              accept="image/png,image/jpeg"
              value={imgobj}
              onChange={(e) => {
                setimgobj(e);
                setPreviewpic(URL.createObjectURL(e));
              }}
            />
            {previewpic && (
              <div style={{ paddingTop: "10px" }}>
                <img
                  style={{ borderRadius: "4px" }}
                  width={"100%"}
                  height={"auto"}
                  src={previewpic}
                  alt=""
                />
              </div>
            )}
            {loading ? (
              <Button disabled type="submit" fullWidth mt="xl">
                Save Profile
              </Button>
            ) : (
              <Button type="submit" fullWidth mt="xl">
                Save Changes
              </Button>
            )}
          </form>
        </Paper>
      </Container>
    </div>
  );
};

export default CompleteProfile;
